import { render } from "./GuestLayout.vue?vue&type=template&id=4fef9e04&scoped=true"
import script from "./GuestLayout.vue?vue&type=script&lang=js"
export * from "./GuestLayout.vue?vue&type=script&lang=js"

import "./GuestLayout.vue?vue&type=style&index=0&id=4fef9e04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fef9e04"]])

export default __exports__